import { SimpleValueMap } from '../../types';
import ValueMapBox from './ValueMapBox';

interface ValueMapVisualProps {
  valueMap: SimpleValueMap;
}

export default function ValueMapVisual({ valueMap }: ValueMapVisualProps) {
  return (
    <div id="value-map-export" className="max-w-2xl mx-auto space-y-8 bg-white p-8 rounded-lg shadow-lg">
      {/* Title */}
      <div className="text-center border-b-2 border-gray-200 pb-4">
        <h1 className="text-3xl font-bold text-gray-900">Value Map</h1>
        <p className="text-gray-600 mt-2">Strategic Business Alignment</p>
      </div>

      {/* Box 1: Business Driver */}
      <ValueMapBox
        title="Business Driver"
        content={valueMap.businessDriver}
        color="orange"
        icon="🎯"
      />

      {/* Arrow Down */}
      <div className="flex justify-center">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>

      {/* Box 2: Pain Point */}
      <ValueMapBox
        title="Pain Point / Challenge"
        content={valueMap.painPoint}
        color="red"
        icon="⚠️"
      />

      {/* Arrow Down */}
      <div className="flex justify-center">
        <svg className="w-8 h-8 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M19 14l-7 7m0 0l-7-7m7 7V3" />
        </svg>
      </div>

      {/* Box 3: Measurable Outcome */}
      <ValueMapBox
        title="Measurable Outcome"
        content={valueMap.measurableOutcome}
        color="green"
        icon="✅"
      />

      {/* Footer */}
      <div className="text-center text-sm text-gray-500 pt-4 border-t border-gray-200">
        <p>Generated by Value Map Coach • Cloudflare</p>
      </div>
    </div>
  );
}
